import { Slider } from 'components/swiper'
import { Image, ReleaseDate, Section, Slide, SlideName, Title } from './styled'
import { Container } from 'components/container'
import { Button } from '../styled'

const slides = [
  {
    image: require('./assets/01000000-c0a8-0242-050c-08dcc820b7ea_w600.jpg'),
    title: 'Лиссабон',
    link: '/a/oir-lissabon-sub/33120147.html',
  },
  {
    image: require('./assets/01000000-c0a8-0242-3d01-08dcc820b7e7_w600.jpg'),
    title: 'Барселона',
    link: '/a/oir-barselona-sub/33120202.html',
  },
  {
    image: require('./assets/01000000-c0a8-0242-9691-08dcc820b7e6_w600.jpg'),
    title: 'Канны, Ницца',
    link: '/a/oir_nicce_subs/33139414.html',
  },
  {
    image: require('./assets/01000000-c0a8-0242-c790-08dcc820b121_w600.jpg'),
    title: 'Милан, Комо',
    link: '/a/oir-milan-sub/33137512.html',
  },
  {
    image: require('./assets/01000000-0a00-0242-7067-08dcc820b10f_w600.jpg'),
    title: 'Рига',
    releaseDate: '13 октября',
  },
  {
    image: require('./assets/01000000-c0a8-0242-7a04-08dcc820b10f_w600.jpg'),
    title: 'Берлин',
    releaseDate: '13 октября',
  },
  {
    image: require('./assets/01000000-c0a8-0242-c945-08dcc820b122_w600.jpg'),
    title: 'Варшава',
    releaseDate: '27 октября',
  },
  {
    title: 'Будапешт',
    releaseDate: '27 октября',
  },
  {
    title: 'Прага',
    releaseDate: '10 ноября',
  },
  {
    title: 'Вена',
    releaseDate: '10 ноября',
  },
  {
    title: 'Бухарест',
    releaseDate: '24 ноября',
  },
  {
    title: 'Афины',
    releaseDate: '24 ноября',
  },
  {
    title: 'Загреб',
    releaseDate: '12 декабря',
  },
  {
    title: 'Мальме',
    releaseDate: '12 декабря',
  },
  {
    title: 'Хельсинки',
    releaseDate: '22 декабря',
  },
  {
    title: 'Роттердам',
    releaseDate: '22 декабря',
  },
]

export const Releases = () => {
  return (
    <Section id="releases">
      <Container>
        <Title>Выпуски</Title>
        <Slider
          titleInNav
          smallTitleSpacing
          slides={slides.map((s, i) => ({
            ...s,
            title: `${i + 1} / ${slides.length}`,
            component: (
              <Slide>
                {!!s.image && <Image src={s.image} alt={s.title} />}
                <SlideName>
                  {i + 1}. {s.title}
                </SlideName>
                {!!s.releaseDate && <ReleaseDate>{s.releaseDate}</ReleaseDate>}
                {!!s.link && (
                  <Button href={s.link} target="_blank">
                    смотреть
                  </Button>
                )}
              </Slide>
            ),
          }))}
        />
      </Container>
    </Section>
  )
}
